/**
 * 常驻今日/昨日业绩卡片 — 首页顶部直接可见，点击打开 DailyPerfModal 明细。
 */
import { useTranslation } from 'react-i18next';
import { OtherPanel } from './WalletShared';
import { WALLET_COLORS as C } from '@/constants';
import { formatWalletBalance } from '@/utils/wallet-display';
import type { WalletDailyPerf } from '@/utils/wallet-daily-perf';

function fmtUsd(raw: string | undefined): string {
  const n = formatWalletBalance(raw ?? '0');
  return n === '0' ? '0$' : `${n}$`;
}

export function DailyPerfCard({
  data,
  onOpen,
}: {
  data?: WalletDailyPerf;
  onOpen: (period: 'today' | 'yesterday') => void;
}) {
  const { t } = useTranslation();

  const items: Array<{ period: 'today' | 'yesterday'; label: string; total?: string }> = [
    {
      period: 'today',
      label: t('wallet.balances.today_perf', '今日业绩'),
      total: data?.today?.total,
    },
    {
      period: 'yesterday',
      label: t('wallet.balances.yesterday_perf', '昨日业绩'),
      total: data?.yesterday?.total,
    },
  ];

  return (
    <OtherPanel className="px-1.5 py-1.5">
      <div className="grid grid-cols-2 gap-0.5">
        {items.map(({ period, label, total }) => (
          <button
            key={period}
            type="button"
            onClick={() => onOpen(period)}
            className="flex min-h-[56px] flex-col items-center justify-center gap-1.5 border px-2 py-2.5 transition active:scale-[0.98]"
            style={{ borderColor: C.otherAsset, background: C.bgAsset, boxShadow: C.shadowAsset }}
          >
            <div className="truncate font-mono text-base font-semibold leading-none" style={{ color: C.gold }}>
              {fmtUsd(total)}
            </div>
            <div className="truncate text-[10px] leading-none" style={{ color: C.muted }}>
              {label} ›
            </div>
          </button>
        ))}
      </div>
    </OtherPanel>
  );
}
